module.exports = __webpack_public_path__ + "img/twitter.90cf71f4.svg";